var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemoTenant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419",
    gradientUnits: "userSpaceOnUse",
    x1: 36.299,
    y1: 20.39,
    x2: 30.596,
    y2: 15.604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.329 18.086c4.461 2.745 5.28-1.033 8.236-.177",
    fill: "none",
    stroke: "url(#SVGID_0_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M29.33 10.539h8.236v10.794c0 .138.09.258.222.3 5.919 1.875 10.137 7.575 9.752 14.198-.405 6.974-6.026 12.662-12.995 13.143-8.189.565-15.008-5.911-15.008-13.979 0-6.189 4.012-11.502 9.576-13.36a.315.315 0 00.217-.298V10.539z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419",
    gradientUnits: "userSpaceOnUse",
    x1: 27.359,
    y1: 35.554,
    x2: 28.056,
    y2: 30.594
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 27.708,
    cy: 33.074,
    r: 1.879,
    fill: "none",
    stroke: "url(#SVGID_1_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419",
    gradientUnits: "userSpaceOnUse",
    x1: 32.967,
    y1: 36.057,
    x2: 33.403,
    y2: 41.047
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 33.185,
    cy: 38.552,
    r: 1.879,
    fill: "none",
    stroke: "url(#SVGID_2_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M37.417 60.49h-7.84a.247.247 0 01-.247-.247v-.365c0-.791.641-1.432 1.432-1.432h5.471c.791 0 1.432.641 1.432 1.432v.365a.248.248 0 01-.248.247z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419",
    gradientUnits: "userSpaceOnUse",
    x1: 32.954,
    y1: 59.037,
    x2: 34.402,
    y2: 52.765
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.229 56.618c0 1.449-.776 1.826-1.732 1.826s-1.732-.378-1.732-1.826c0-1.449 1.732-3.42 1.732-3.42s1.732 1.971 1.732 3.42z",
    fill: "none",
    stroke: "url(#SVGID_3_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419",
    gradientUnits: "userSpaceOnUse",
    x1: 32.247,
    y1: 27.714,
    x2: 38.412,
    y2: 27.714
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 35.33,
    cy: 27.714,
    r: 2.457,
    fill: "#FFF",
    stroke: "url(#SVGID_4_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419",
    gradientUnits: "userSpaceOnUse",
    x1: 35.618,
    y1: 5.172,
    x2: 31.482,
    y2: 12.633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.764 10.5h-8.429a1.597 1.597 0 01-1.597-1.597v0c0-.882.715-1.597 1.597-1.597h8.429c.882 0 1.597.715 1.597 1.597v0c0 .882-.715 1.597-1.597 1.597z",
    fill: "none",
    stroke: "url(#SVGID_5_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419",
    gradientUnits: "userSpaceOnUse",
    x1: 16.683,
    y1: 52.886,
    x2: 50.433,
    y2: 52.886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M17.308 60.49l3.454-15.641h-2.037 29.267-1.771l3.587 16.073"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419",
    gradientUnits: "userSpaceOnUse",
    x1: 57.771,
    y1: 40.965,
    x2: 73.873,
    y2: 40.965
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.396 40.97s4.447-2.126 7.426-1.068c4.251 1.51 5.876 2.529 7.426 2.413",
    fill: "none",
    stroke: "url(#SVGID_7_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M61.421 33.411l-6.839 17.093a1.99 1.99 0 001.848 2.73h18.264a1.99 1.99 0 001.849-2.729L69.722 33.41a1.3 1.3 0 01-.093-.485V22.683h-8.114v10.241a1.33 1.33 0 01-.094.487zM63.745 25.705h1.616M63.745 29.142h1.616M63.745 32.579h1.616"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419",
    gradientUnits: "userSpaceOnUse",
    x1: 64.375,
    y1: 24.521,
    x2: 66.891,
    y2: 17.609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.826 22.683H61.44a1.618 1.618 0 01-1.618-1.618v0c0-.894.725-1.618 1.618-1.618h8.386c.894 0 1.618.725 1.618 1.618v0c0 .894-.724 1.618-1.618 1.618z",
    fill: "none",
    stroke: "url(#SVGID_8_59313b8b8a975e8d36e8400dd5c6c6c9366eb8e53b9776309e5458b5c9af3419)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoTenant);
export default __webpack_public_path__ + "static/media/demoTenant.a1739c4568e84b952a4d5d513da13f97.svg";
export { ForwardRef as ReactComponent };